// src/pages/CourseTime/components/slides/layouts/DecisionPointSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import NoDataFallback from '../common/NoDataFallback.comp';
import SlideTitleSpoken from '../common/SlideTitleSpoken.comp';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layout: TemplateDecisionPoint
const DecisionPointSlide = ({ slide, renderSpokenText, skipTitleSpeech, themeColor }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  const dp = slide.DecisionData;
  const accent = themeColor || '#3D5AFE';
  if (!dp) {
    return (
      <NoDataFallback
        slide={slide}
        skipTitleSpeech={skipTitleSpeech}
        renderSpokenText={renderSpokenText}
        renderContent={renderContent}
      />
    );
  }
  return (
    <S.SlideDescription>
      <S.SlideTitle>
        <SlideTitleSpoken slide={slide} skipTitleSpeech={skipTitleSpeech} renderSpokenText={renderSpokenText} />
      </S.SlideTitle>
      {dp.decision_question && (
        <div style={{ borderLeft: `4px solid ${accent}`, background: `${accent}10`, padding: '12px 16px', borderRadius: 8, margin: '8px 0 12px', fontWeight: 600 }}>
          {renderContent('dp_q', dp.decision_question)}
        </div>
      )}
      {dp.context_hint && (
        <S.PointText style={{ fontStyle: 'italic', marginBottom: 8 }}>
          {renderContent('dp_hint', dp.context_hint)}
        </S.PointText>
      )}
      <ul>
        {(dp.options || []).map((o, idx) => (
          <li key={idx}>
            <S.PointText>{renderContent(`dp_opt_${idx}`, o)}</S.PointText>
          </li>
        ))}
      </ul>
    </S.SlideDescription>
  );
};

export default DecisionPointSlide;
